module.exports = "/_next/static/images/OCLogo-0b7941099718cc6182c5fa1846f43400.png";